import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLogoViral, LazyLogoViralInfluencer, LazyLogoViralText, LazyPanelAddInfluencers, LazyPanelCompanyFinances, LazyPanelConfigureWithdrawal, LazyPanelCreateInfluencerPartnership, LazyPanelCreateList, LazyPanelDailyGoals, LazyPanelEditCampaignApproach, LazyPanelEditList, LazyPanelGenerateCoupons, LazyPanelInfluencerPartnershipFromCampaignOrigin, LazyPanelInfluencerPartnershipFromInfluencerOrigin, LazyPanelInfluencerPartnershipFromViralLinkOrigin, LazyPanelLanguage, LazyPanelMidiaKitAppearance, LazyPanelMidiaKitPreferences, LazyPanelResearchHashtagPosts, LazyPanelResearchInfluencersBio, LazyPanelResearchRelatedInfluencers, LazyPanelResearchTaggedPosts, LazyPanelViralLinkAppearance, LazyPanelViralLinkContactForm, LazyPanelViralLinkFeedPostLink, LazyPanelViralLinkPreferences, LazyPanelViralLinkUrl, LazyPanelViralLinkYouTubeLink, LazyToggleLanguage, LazyToggleTheme, LazyToolbarCompanyCredits, LazyToolbarCompanyMenu, LazyToolbarCompanyNotifications, LazyToolbarInfluencerMenu, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["LogoViral", LazyLogoViral],
["LogoViralInfluencer", LazyLogoViralInfluencer],
["LogoViralText", LazyLogoViralText],
["PanelAddInfluencers", LazyPanelAddInfluencers],
["PanelCompanyFinances", LazyPanelCompanyFinances],
["PanelConfigureWithdrawal", LazyPanelConfigureWithdrawal],
["PanelCreateInfluencerPartnership", LazyPanelCreateInfluencerPartnership],
["PanelCreateList", LazyPanelCreateList],
["PanelDailyGoals", LazyPanelDailyGoals],
["PanelEditCampaignApproach", LazyPanelEditCampaignApproach],
["PanelEditList", LazyPanelEditList],
["PanelGenerateCoupons", LazyPanelGenerateCoupons],
["PanelInfluencerPartnershipFromCampaignOrigin", LazyPanelInfluencerPartnershipFromCampaignOrigin],
["PanelInfluencerPartnershipFromInfluencerOrigin", LazyPanelInfluencerPartnershipFromInfluencerOrigin],
["PanelInfluencerPartnershipFromViralLinkOrigin", LazyPanelInfluencerPartnershipFromViralLinkOrigin],
["PanelLanguage", LazyPanelLanguage],
["PanelMidiaKitAppearance", LazyPanelMidiaKitAppearance],
["PanelMidiaKitPreferences", LazyPanelMidiaKitPreferences],
["PanelResearchHashtagPosts", LazyPanelResearchHashtagPosts],
["PanelResearchInfluencersBio", LazyPanelResearchInfluencersBio],
["PanelResearchRelatedInfluencers", LazyPanelResearchRelatedInfluencers],
["PanelResearchTaggedPosts", LazyPanelResearchTaggedPosts],
["PanelViralLinkAppearance", LazyPanelViralLinkAppearance],
["PanelViralLinkContactForm", LazyPanelViralLinkContactForm],
["PanelViralLinkFeedPostLink", LazyPanelViralLinkFeedPostLink],
["PanelViralLinkPreferences", LazyPanelViralLinkPreferences],
["PanelViralLinkUrl", LazyPanelViralLinkUrl],
["PanelViralLinkYouTubeLink", LazyPanelViralLinkYouTubeLink],
["ToggleLanguage", LazyToggleLanguage],
["ToggleTheme", LazyToggleTheme],
["ToolbarCompanyCredits", LazyToolbarCompanyCredits],
["ToolbarCompanyMenu", LazyToolbarCompanyMenu],
["ToolbarCompanyNotifications", LazyToolbarCompanyNotifications],
["ToolbarInfluencerMenu", LazyToolbarInfluencerMenu],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
